import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { searchInCouncil } from "modules/companies/companyMain/companyMain.action";
import {
  projectCompanyNewMultiple,
  projectPatientOrgNewMultiple,
} from "modules/projects/project/companies/companies.action";
import { ModalBody, ModalFooter } from "../../../application/modal";
import {
  BtnType,
  Button,
  Label,
  MultiSelect,
  Loading,
} from "../../../modules/primitives";
import styles from "./addCompany.module.scss";
import { useModelPopup } from "../../hooks";

const AddCompanyComponent = (props) => {
  const { stage, patientOrg, handleCompanyAdd, itemList } = props;
  const dispatch = useDispatch();
  const popup = useModelPopup();
  const { enqueueSnackbar } = useSnackbar();
  const [selected, setSelected] = useState([]);
  const [options, setOptions] = useState([]);
  const [elasticQueryy, setElasticQuery] = useState("");

  const {
    authReducer: { session },
    councilReducer: { selectedCouncil },
    companiesReducer: {
      companyMainReducer: { searchResults, loading },
    },
    projectsReducer: {
      projectReducer: { selectedProject },
    },
  } = useSelector((state) => state);

  const handleOptionSelect = (values) => {
    setSelected(values);
  };

  const handleTypeSearch = (val) => {
    setElasticQuery(val.search);
  };

  const handleCancelClick = () => {
    popup.hide();
  };

  const handleSaveClick = useCallback(() => {
    if (selected.length > 0) {
      if (patientOrg) {
        const multiPatientOrgPayload = {
          project_patient_organizations: selected.map((s) => ({
            project_id: selectedProject?.id,
            gsk_patient_organization_id: s.id,
            added_by_id: session.id,
            stage_id: stage.id,
          })),
          project_id: selectedProject?.id,
          council_id: selectedCouncil.id,
          patientOrg: true,
          stage_id: stage.id,
          enqueueSnackbar,
        };

        dispatch(projectPatientOrgNewMultiple(multiPatientOrgPayload));
      } else {
        const multiCompaniesPayload = {
          project_companies: selected.map((s) => ({
            project_id: selectedProject.id,
            company_id: s.company_id,
            added_by_id: session.id,
            stage_id: stage.id,
          })),
          project_id: selectedProject.id,
          council_id: selectedCouncil.id,
          patientOrg: false,
          stage_id: stage.id,
          enqueueSnackbar,
        };

        dispatch(projectCompanyNewMultiple(multiCompaniesPayload));
      }

      if (handleCompanyAdd) handleCompanyAdd();

      popup.hide();
    }
  }, [selectedCouncil, stage, session, selectedProject, selected, patientOrg]);

  useEffect(() => {
    dispatch(
      searchInCouncil({
        data: elasticQueryy,
        council_id: selectedCouncil.id,
        project_id: selectedProject?.id,
        mode:
          patientOrg && patientOrg ? "gsk/patient_organizations" : "companies",
        enqueueSnackbar,
        showSimilar: false,
        cb: () => {},
        isDropDown: true,
      })
    );
  }, [elasticQueryy]);

  useEffect(() => {
    if (searchResults && itemList && searchResults.length > 0) {
      const filteredOptions = searchResults.filter((option) => {
        const isAlreadySelected = itemList.find(
          (item) =>
            item?.gsk_patient_organization?.id === option.id ||
            item?.company?.id === option.id
        );

        return !isAlreadySelected;
      });
      setOptions(filteredOptions);
    }
  }, [searchResults, patientOrg, itemList]);

  return (
    <div className={styles.addCompanyWrp}>
      <ModalBody>
        <Label>
          {patientOrg && patientOrg ? "Organizations" : "Companies"}
        </Label>
        <div className={styles.selectorWrp}>
          <MultiSelect
            onChange={handleOptionSelect}
            placeholder={`Add ${
              patientOrg && patientOrg ? "Organizations" : "Companies"
            } (type to search or select from below)`}
            labelField="name"
            valueField="id"
            searchBy="name"
            options={options}
            searchFn={(args) => {
              handleTypeSearch(args.state);
            }}
          />
          <div className={styles.loaderWrp}>
            {loading && <Loading hideString />}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button btn={BtnType.FRAME_LESS} onClick={handleCancelClick}>
          Cancel
        </Button>
        <Button type="submit" btn={BtnType.REGULAR} onClick={handleSaveClick}>
          Save
        </Button>
      </ModalFooter>
    </div>
  );
};

export default React.memo(AddCompanyComponent);
